import { useMutation, UseMutationOptions } from 'react-query'
import {
  pushDangerNotification,
  pushSuccessNotification,
  TranslationDictionary,
  useLocale
} from '@plandi/common'

import { projectsApi } from '../projects.api'
import { useThunkDispatch } from 'src/store'
import { AxiosError } from 'axios'

type MutationParams = {
  name: string
  sender: string
  message: string
}

export const useMutationHelpSearchProject = (
  translate?: TranslationDictionary['data'],
  options?: UseMutationOptions<unknown, AxiosError, MutationParams>
) => {
  const dispatch = useThunkDispatch()
  const locale = useLocale()

  const mutation = useMutation(
    ({ name, sender, message }) =>
      projectsApi.sendSearchHelpRequest(name, sender, message, locale),
    {
      ...options,
      onSuccess: () => {
        dispatch(
          pushSuccessNotification(translate?.['email-sent-successfully'] ?? '')
        )
      },
      onError: () => {
        dispatch(pushDangerNotification(translate?.['error-send-email'] ?? ''))
      }
    }
  )

  return mutation
}
